import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import React from "react";
import { loginRequest } from "./AuthConfig";

function LoginRedirect() {
   const isAuthenticated = useIsAuthenticated();
   const { instance } = useMsal();
   const inProgress = window.sessionStorage.getItem("msal_progress");
   if (!isAuthenticated && !inProgress) {
      window.sessionStorage.setItem("msal_progress", "true");
      instance.loginRedirect(loginRequest).catch((error) => {
         console.error(error);
         window.sessionStorage.removeItem("msal_progress");
         alert("로그인 중 에러가 발생하였습니다.");
         window.location.replace("https://testportal.weareinbody.com");
      });
   }
   return <div></div>;
}

export default LoginRedirect;
